module.exports = __webpack_public_path__ + "e9fe8580b722aefbb75ffcaa2cc22998.json";


//////////////////
// WEBPACK FOOTER
// ./src/portal/i18n/zh.json
// module id = 1042
// module chunks = 0